<template>
<div class="chapter">
<div class="inner_page">
<div id="about-this-book">
<div class="story">
<p class="ahead"><span class="generated-style">About This Book</span></p>
<p class="txnoi"><span class="generated-style">The basis for this Book of Shadows is an unfinished manuscript Scott Cunningham started more than thirty years ago. The way it was placed in an envelope with the title shows us Scott intended it to be published.</span></p>
<p class="tx"><span class="generated-style">We believe it would be a disservice to publish it in “the raw,” and for that reason we have excerpted passages from Scott’s previously published books to serve as introductions to sections or to create bridges where material was not completed. The primary resource was</span><span class="ital"> Wicca: A Guide for the Solitary Practitioner</span><span class="generated-style">, and those passages are noted for clarity. None of Scott’s original words were changed for this book.</span></p>
<p class="tx"><span class="generated-style">The original manuscript was produced on a red IBM Selectric® typewriter, and many of those pages have been reproduced exactly as they were created, including Scott’s handwritten notes and corrections in the margins. Also, many of the hand-drawn symbols and related artwork have been reproduced just as he drew them.</span></p>
<p class="tx"><span class="generated-style">This is not a traditional Book of Shadows because Scott intended to create something truly unique. The genesis of that idea and the content of the book is explained in the “How to Use This Book” section written by Scott’s publisher, Carl Llewellyn Weschcke.</span></p>
<p class="tx"><span class="generated-style">The appendices contain memories of Scott from some of his siblings, teachers, and closest friends.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_This_Book.vue?17307d78